
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  // Close services menu when navigating to a service page
  useEffect(() => {
    if (location.pathname.startsWith('/hizmetler/')) {
      setIsServicesOpen(false);
    }
  }, [location.pathname]);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-heading font-bold text-dark">
              <span className="text-primary">Yıldırım</span> Reklam
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`font-medium transition-colors ${isActive('/') ? 'text-primary' : 'text-dark hover:text-primary'}`}
            >
              Ana Sayfa
            </Link>
            <Link 
              to="/hakkimizda" 
              className={`font-medium transition-colors ${isActive('/hakkimizda') ? 'text-primary' : 'text-dark hover:text-primary'}`}
            >
              Hakkımızda
            </Link>
            
            {/* Services Mega Menu */}
            <div className="relative">
              <button 
                onClick={toggleServices}
                className="font-medium text-dark hover:text-primary flex items-center"
              >
                Hizmetler
                <i className={`ri-arrow-${isServicesOpen ? 'up' : 'down'}-s-line ml-1`}></i>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 w-96 bg-white shadow-xl rounded-lg p-6 mt-2 border">
                  <div className="grid grid-cols-1 gap-6">
                    <div>
                      <h3 className="font-semibold text-dark mb-3 flex items-center">
                        <div className="w-6 h-6 bg-primary rounded flex items-center justify-center mr-2">
                          <i className="ri-printer-line text-white text-sm"></i>
                        </div>
                        Dijital Baskı
                      </h3>
                      <div className="space-y-2 ml-8">
                        <Link 
                          to="/hizmetler/dijital-baski" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Dijital Baskı Hizmetleri
                        </Link>
                        <Link 
                          to="/hizmetler/folyo-baski" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Folyo Baskı
                        </Link>
                        <Link 
                          to="/hizmetler/ic-mekan-baski" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          İç Mekan Baskı
                        </Link>
                        <Link 
                          to="/hizmetler/baskes" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Baskes
                        </Link>
                        <Link 
                          to="/hizmetler/kuse-etiket" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Kuşe Etiket
                        </Link>
                        <Link 
                          to="/hizmetler/promosyon" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Promosyon
                        </Link>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-dark mb-3 flex items-center">
                        <div className="w-6 h-6 bg-primary rounded flex items-center justify-center mr-2">
                          <i className="ri-lightbulb-line text-white text-sm"></i>
                        </div>
                        Tabela & Işıklı Sistemler
                      </h3>
                      <div className="space-y-2 ml-8">
                        <Link 
                          to="/hizmetler/tabela-sistemleri" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Tabela Sistemleri
                        </Link>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-dark mb-3 flex items-center">
                        <div className="w-6 h-6 bg-primary rounded flex items-center justify-center mr-2">
                          <i className="ri-car-line text-white text-sm"></i>
                        </div>
                        Araç & Cephe
                      </h3>
                      <div className="space-y-2 ml-8">
                        <Link 
                          to="/hizmetler/arac-giydirme" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Araç Giydirme
                        </Link>
                        <Link 
                          to="/hizmetler/cephe-kaplama" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          Cephe Kaplama
                        </Link>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-dark mb-3 flex items-center">
                        <div className="w-6 h-6 bg-primary rounded flex items-center justify-center mr-2">
                          <i className="ri-tools-line text-white text-sm"></i>
                        </div>
                        CNC & Lazer
                      </h3>
                      <div className="space-y-2 ml-8">
                        <Link 
                          to="/hizmetler/cnc-lazer" 
                          className="block text-sm text-gray-600 hover:text-primary flex items-center"
                          onClick={() => setIsServicesOpen(false)}
                        >
                          <i className="ri-arrow-right-s-line text-primary mr-1"></i>
                          CNC & Lazer İşleri
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link 
              to="/portfolyo" 
              className={`font-medium transition-colors ${isActive('/portfolyo') ? 'text-primary' : 'text-dark hover:text-primary'}`}
            >
              Portföy
            </Link>
            <Link 
              to="/blog" 
              className={`font-medium transition-colors ${isActive('/blog') ? 'text-primary' : 'text-dark hover:text-primary'}`}
            >
              Blog
            </Link>
            <Link 
              to="/iletisim" 
              className={`font-medium transition-colors ${isActive('/iletisim') ? 'text-primary' : 'text-dark hover:text-primary'}`}
            >
              İletişim
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:+903123808099" className="text-dark hover:text-primary">
              <i className="ri-phone-line text-xl"></i>
            </a>
            <Link to="/teklif-al">
              <Button>Teklif Al</Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <nav className="space-y-4">
              <Link to="/" className="block font-medium text-dark">Ana Sayfa</Link>
              <Link to="/hakkimizda" className="block font-medium text-dark">Hakkımızda</Link>
              <Link to="/hizmetler" className="block font-medium text-dark">Hizmetler</Link>
              <Link to="/portfolyo" className="block font-medium text-dark">Portföy</Link>
              <Link to="/blog" className="block font-medium text-dark">Blog</Link>
              <Link to="/iletisim" className="block font-medium text-dark">İletişim</Link>
              <Link to="/teklif-al">
                <Button className="w-full">Teklif Al</Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
